// src/pages/Contact.jsx
import {
  Box
} from "@mui/material";
import "../styles/Contact.css";
import ContactUs from "../components/ContactUs";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>Contact Us | KRM Landscape</title>
        <meta
          name="description"
          content="Contact KRM Landscape for professional landscaping services, consultations, and garden solutions."
        />
        <meta
          name="keywords"
          content="KRM Landscape, contact, landscaping services, garden solutions, professional landscapers"
        />
      </Helmet>

      <Box>
        <ContactUs />
      </Box>
    </>
  );
};

export default Contact;






